webpackJsonp([193313036739389],{

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.EmploymentCard = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _arrowIcon = __webpack_require__(171);
	
	var _arrowIcon2 = _interopRequireDefault(_arrowIcon);
	
	var _link = __webpack_require__(9);
	
	var _styles = __webpack_require__(249);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmploymentCard = exports.EmploymentCard = function EmploymentCard(_ref) {
		var to = _ref.to,
		    title = _ref.title,
		    body = _ref.body,
		    img = _ref.img,
		    linkText = _ref.linkText;
		return _react2.default.createElement(
			_link.Link,
			{ className: _styles.wrapperLinkStyle, to: to, 'data-component': 'Card' },
			_react2.default.createElement(
				'article',
				{ className: _styles.wrapperStyle },
				_react2.default.createElement('img', { src: img, alt: '', className: _styles.imgStyle }),
				_react2.default.createElement(
					'h1',
					{ className: _styles.titleStyle },
					title
				),
				_react2.default.createElement(
					'p',
					{ className: _styles.bodyStyle },
					body
				),
				_react2.default.createElement(
					'p',
					{ className: _styles.ctaStyle },
					linkText,
					' ',
					_react2.default.createElement(_arrowIcon2.default, null)
				)
			)
		);
	};
	
	EmploymentCard.propTypes = {
		to: _propTypes2.default.string.isRequired,
		title: _propTypes2.default.string.isRequired,
		body: _propTypes2.default.string.isRequired,
		linkText: _propTypes2.default.string,
		img: _propTypes2.default.string
	};

/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(247);
	
	Object.keys(_component).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _component[key];
	    }
	  });
	});

/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ctaStyle = exports.bodyStyle = exports.titleStyle = exports.imgStyle = exports.wrapperStyle = exports.wrapperLinkStyle = undefined;
	
	var _css, _css2, _css3;
	
	var _emotion = __webpack_require__(6);
	
	var _globalStyles = __webpack_require__(4);
	
	var _mediaIcon = __webpack_require__(168);
	
	var _mediaIcon2 = _interopRequireDefault(_mediaIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var padding = 24;
	
	var wrapperLinkStyle = /*#__PURE__*/exports.wrapperLinkStyle = (0, _emotion.css)({
		textDecoration: 'none',
		display: 'block'
	});
	
	var wrapperStyle = /*#__PURE__*/exports.wrapperStyle = (0, _emotion.css)({
		textDecoration: 'none',
		border: '1px solid ' + _globalStyles.lightGrey,
		borderRadius: '6px',
		backgroundColor: '#fff',
		boxSizing: 'border-box',
		padding: padding + 'px',
		height: '100%'
	});
	
	var imgStyle = /*#__PURE__*/exports.imgStyle = (0, _emotion.css)({
		display: 'block',
		marginBottom: padding / 2,
		maxWidth: '98px'
	});
	
	var titleStyle = exports.titleStyle = (0, _emotion.cx)(_globalStyles.headingSmallLight, /*#__PURE__*/(0, _emotion.css)((_css = {
		marginBottom: '12px'
	}, _css['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		fontSize: '14px',
		lineHeight: '16px'
	}, _css)));
	
	var bodyStyle = exports.bodyStyle = (0, _emotion.cx)(_globalStyles.textBlock, /*#__PURE__*/(0, _emotion.css)((_css2 = {
		marginTop: 0,
		marginBottom: padding
	}, _css2['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		display: 'none'
	}, _css2)));
	
	var ctaStyle = /*#__PURE__*/exports.ctaStyle = (0, _emotion.css)((_css3 = {
		fontSize: '16px',
		lineHeight: '24px',
		marginTop: 0,
		marginBottom: 0,
		color: _globalStyles.pink,
		fontWeight: 'bold',
		/*fontWeight: 'bold'*/
		'& svg': {
			marginLeft: '2px'
		}
	}, _css3['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		fontSize: '12px'
	}, _css3));

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.researchButton = exports.researchBannerButtonSection = exports.researchBannerInnerStyle = exports.researchBannerStyle = exports.innerWrapperStyle = exports.headerWrapperStyle = exports.locationSelectorInnerStyle = exports.locationSelectorStyle = exports.employmentInterestedCardStyle = undefined;
	
	var _css, _css2;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _emotion = __webpack_require__(6);
	
	var _globalStyles = __webpack_require__(4);
	
	var _dropdownIcon = __webpack_require__(235);
	
	var _dropdownIcon2 = _interopRequireDefault(_dropdownIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var employmentInterestedCardStyle = /*#__PURE__*/exports.employmentInterestedCardStyle = (0, _emotion.css)({
		background: _globalStyles.lightGrey,
		border: _globalStyles.lightGrey,
		borderRadius: '6px',
		padding: '24px',
		display: 'block',
		textDecoration: 'none',
		'& h1': (0, _emotion.cx)(_globalStyles.headingMedium, /*#__PURE__*/(0, _emotion.css)({
			marginBottom: '12px'
		})),
		'& p': (0, _emotion.cx)(_globalStyles.textBlock, /*#__PURE__*/(0, _emotion.css)({
			margin: '0 0 24px 0'
		}))
	});
	
	var locationSelectorStyle = /*#__PURE__*/exports.locationSelectorStyle = (0, _emotion.css)({
		maxWidth: _globalStyles.desktopMaxWidthBreakpoint,
		height: '106px',
		width: '100%',
		margin: '0 auto',
		padding: '0 20px',
		display: 'table'
	});
	
	var locationSelectorInnerStyle = /*#__PURE__*/exports.locationSelectorInnerStyle = (0, _emotion.css)({
		display: 'table-cell',
		verticalAlign: 'middle',
		'& label': _extends({}, _globalStyles.museo500, {
			fontSize: '22px',
			lineHeight: '27px',
			marginRight: '55px'
		}),
		'& select': {
			marginLeft: '24px',
			border: '1px solid ' + _globalStyles.lightGrey,
			color: _globalStyles.darkGrey,
			borderRadius: '4px',
			fontSize: '16px',
			lineHeight: '18px',
			padding: '14px 18px',
			minWidth: '300px',
			appearance: 'none',
			cursor: 'pointer',
			background: '#F6F6F6 url(' + _dropdownIcon2.default + ') no-repeat calc(100% - 16px) center'
		}
	});
	
	var headerWrapperStyle = /*#__PURE__*/exports.headerWrapperStyle = (0, _emotion.css)({
		maxWidth: _globalStyles.desktopMaxWidthBreakpoint,
		width: '100%',
		height: '100%',
		margin: '0 auto',
		'& > h1, & > div': {
			padding: '0 20px'
		}
	});
	
	var innerWrapperStyle = /*#__PURE__*/exports.innerWrapperStyle = (0, _emotion.css)({
		maxWidth: _globalStyles.desktopMaxWidthBreakpoint,
		width: '100%',
		height: '100%',
		margin: '0 auto',
		padding: '0 20px',
		overflowX: 'hidden'
	});
	
	var researchBannerStyle = /*#__PURE__*/exports.researchBannerStyle = (0, _emotion.css)((_css = {
		background: _globalStyles.blue,
		position: 'relative',
		width: '100%',
		height: '280px',
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		padding: '0 50px'
	}, _css['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		height: 'auto',
		padding: '30px 15px'
	}, _css['@media (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
		flexDirection: 'column',
		height: 'auto',
		padding: '30px 15px'
	}, _css));
	
	var researchBannerInnerStyle = /*#__PURE__*/exports.researchBannerInnerStyle = (0, _emotion.css)((_css2 = {
		flex: 1,
	
		'& > h2': (0, _emotion.cx)(_globalStyles.headingLarge, /*#__PURE__*/(0, _emotion.css)({
			color: '#fff'
		})),
		'& > div': /*#__PURE__*/(0, _emotion.css)({
			color: '#fff'
		})
	}, _css2['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		top: '0',
		transform: 'none'
	}, _css2));
	
	var researchBannerButtonSection = /*#__PURE__*/exports.researchBannerButtonSection = (0, _emotion.css)({
		flex: 1,
		flexDirection: 'column',
		width: '100%',
		textAlign: 'center',
		padding: '50px 30px 30px 30px'
	});
	
	var researchButton = /*#__PURE__*/exports.researchButton = (0, _emotion.css)(_extends({}, _globalStyles.museo900, {
		display: 'inline-block',
		background: _globalStyles.pink,
		border: 'none',
		color: '#fff',
		fontSize: '18px',
		lineHeight: '15px',
		letterSpacing: '0.5',
		borderRadius: '4px',
		textTransform: 'uppercase',
		textDecoration: 'none',
		padding: '15px 17px 11px 17px'
	}));

/***/ }),

/***/ 1142:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _navManager = __webpack_require__(22);
	
	var _pageHeader = __webpack_require__(19);
	
	var _pageNav = __webpack_require__(27);
	
	var _link = __webpack_require__(9);
	
	var _cards = __webpack_require__(17);
	
	var _pagination = __webpack_require__(78);
	
	var _colouredCard = __webpack_require__(61);
	
	var _employmentCard = __webpack_require__(248);
	
	var _employment = __webpack_require__(480);
	
	var _globalStyles = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var linkWithFilter = function linkWithFilter(_ref) {
		var type = _ref.type,
		    page = _ref.page;
	
		var pieces = ['employment'];
		if (type === 'in-sector') {
			pieces.push('in-sector');
		}
		if ((page || 1) !== 1) pieces.push(page);
		return '/' + pieces.join('/');
	};
	
	var EmploymentPage = function (_React$PureComponent) {
		_inherits(EmploymentPage, _React$PureComponent);
	
		function EmploymentPage() {
			_classCallCheck(this, EmploymentPage);
	
			return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
		}
	
		EmploymentPage.prototype.render = function render() {
			var _ref2;
	
			var type = this.props.pathContext.type;
			var _props$pathContext = this.props.pathContext,
			    pageNumber = _props$pathContext.pageNumber,
			    totalPages = _props$pathContext.totalPages;
			var employment = this.props.data.employment;
	
			var pageSettings = this.props.data.page.edges[0].node;
	
			var EmploymentInterestedCard = function EmploymentInterestedCard() {
				return _react2.default.createElement(
					_link.Link,
					{
						to: '/employment/expression-of-interest',
						'data-component': 'Card',
						className: _employment.employmentInterestedCardStyle
					},
					_react2.default.createElement(
						'article',
						null,
						_react2.default.createElement(
							'h1',
							null,
							'Interested in contributing to our work at InsideOut?'
						),
						_react2.default.createElement(
							'p',
							null,
							'Complete an expression of interest and we\u2019ll will get back to you.'
						),
						_react2.default.createElement(
							'span',
							{ className: (0, _globalStyles.button)(_globalStyles.pink) },
							'Apply Now'
						)
					)
				);
			};
	
			return _react2.default.createElement(
				_react2.default.Fragment,
				null,
				_react2.default.createElement(
					_reactHelmet.Helmet,
					{ title: 'Employment' },
					_react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
					_react2.default.createElement('meta', { property: 'og:title', content: 'InsideOut - Employment' })
				),
				_react2.default.createElement(_pageHeader.PageHeader, {
					background: '#fff',
					titleText: pageSettings.heading,
					titleTextColor: _globalStyles.darkGrey,
					subTitleText: pageSettings.body,
					subTitleTextColor: _globalStyles.grey,
					pageNav: _react2.default.createElement(_pageNav.PageNav, {
						textColor: _globalStyles.grey,
						activeTextColor: _globalStyles.darkGrey,
						activeUnderlineColor: _globalStyles.aqua,
						links: [{
							to: '/employment',
							text: 'Employment at InsideOut',
							isActive: function isActive() {
								return type === 'inside-out-position';
							}
						}, {
							to: '/employment/in-sector',
							text: 'Employment in the sector across Australia',
							isActive: function isActive() {
								return type === 'in-sector';
							}
						}]
					})
				}),
				_react2.default.createElement(
					'section',
					{ className: (0, _globalStyles.contentSection)('#F6F6F6', '30px') },
					_react2.default.createElement(
						'div',
						{ className: _employment.innerWrapperStyle },
						_react2.default.createElement(
							'div',
							{ className: (0, _globalStyles.cardSection)() },
							_react2.default.createElement(
								_cards.Cards,
								{
									columns: 2,
									scrollable: false,
									columnsAt: (_ref2 = {}, _ref2['max-width: ' + _globalStyles.mobileMaxWidthBreakpoint] = 1, _ref2)
								},
								type === 'in-sector' && pageNumber === 1 && _react2.default.createElement(_colouredCard.ColouredCard, {
									id: 0,
									to: '/employment/submit',
									minHeight: 'auto',
									background: _globalStyles.pink,
									title: 'Want to advertise an employment opportunity?',
									body: 'If you wish to advertise an employment opportunity in the eating disorders sector on our website, let us know.',
									arrow: true
								}),
								employment && employment.edges.map(function (_ref3, index) {
									var node = _ref3.node;
									return _react2.default.createElement(_employmentCard.EmploymentCard, {
										key: index,
										to: (0, _navManager.idToLink)(node.id),
										title: node.title,
										body: node.extract,
										linkText: 'View Details',
										img: node.organisation_logo
									});
								}),
								type === 'inside-out-position' && _react2.default.createElement(EmploymentInterestedCard, null)
							)
						),
						totalPages !== 1 && _react2.default.createElement(_pagination.Pagination, {
							initialPage: pageNumber,
							pageCount: totalPages,
							onPageChange: function onPageChange(page) {
								(0, _link.navigateTo)(linkWithFilter({ type: type, page: page }));
							}
						})
					)
				),
				pageSettings.blue_banner_text && _react2.default.createElement(
					'div',
					{ className: _employment.researchBannerStyle },
					_react2.default.createElement(
						'div',
						{ className: _employment.researchBannerInnerStyle },
						_react2.default.createElement(
							'h2',
							null,
							pageSettings.blue_banner_heading
						),
						_react2.default.createElement('div', {
							dangerouslySetInnerHTML: {
								__html: pageSettings.blue_banner_text
							}
						})
					),
					_react2.default.createElement(
						'div',
						{ className: _employment.researchBannerButtonSection },
						_react2.default.createElement(
							_link.Link,
							{ className: _employment.researchButton, to: pageSettings.blue_banner_button_url },
							pageSettings.blue_banner_button_text
						)
					)
				)
			);
		};
	
		return EmploymentPage;
	}(_react2.default.PureComponent);
	
	EmploymentPage.propTypes = {
		pathContext: _propTypes2.default.shape({
			pageNumber: _propTypes2.default.number.isRequired,
			totalPages: _propTypes2.default.number.isRequired,
			type: _propTypes2.default.string
		}).isRequired,
	
		data: _propTypes2.default.shape({
			page: _propTypes2.default.shape({
				edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
					node: _propTypes2.default.shape({
						heading: _propTypes2.default.string.isRequired,
						body: _propTypes2.default.string.isRequired
					}).isRequired
				})).isRequired
			}).isRequired,
	
			employment: _propTypes2.default.shape({
				edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
					node: _propTypes2.default.shape({
						id: _propTypes2.default.string.isRequired,
						title: _propTypes2.default.string.isRequired,
						organisation: _propTypes2.default.string.isRequired,
						organisation_logo: _propTypes2.default.string.isRequired,
						extract: _propTypes2.default.string.isRequired
					})
				}))
			})
		})
	};
	exports.default = EmploymentPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-employment-index-js-042bbf7a1021f9c6e908.js